
import React from 'react';
import { createRoot } from 'react-dom/client';
import Loader from './Loader';

let loaderRoot = null;


const showLoader = () => {
  if (!loaderRoot) {
    const container = document.createElement('div');
    document.body.appendChild(container);
    loaderRoot = createRoot(container);
  }
  loaderRoot.render(<Loader />);
};

const hideLoader = () => {
  if (loaderRoot) {
    loaderRoot.render(null);
  }
};

export { showLoader, hideLoader };
